import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Carousel } from '@platzi/ui';
import { clientRequest } from '@platzi/commons';
import { schoolsApi } from 'src/services/api/index';
import { TitleSection } from '../';
import { ChallengesCard } from './ChallengesCard';
import styles from './Challenges.module.sass';

export const Challenges = (props) => {
  const RoutesIds = useSelector((state) => state.get('school').get('lps_ids')).toJS() || [];
  const [challenges, setChallenges] = useState([]);
  const { t } = useTranslation();

  const elementsByBreakpoint = { xs: 1, sm: 1, md: 2, lg: 2 };

  useEffect(() => {
    clientRequest('challenges', {
      method: 'get',
      requestURL: schoolsApi.client.schools.challenges(RoutesIds.toString()),
    })
      .then((res) => {
        setChallenges(res);
        props.setShowChallenges(res.length > 0);
      })
      .catch((err) => {
        throw new Error('::ERROR::SCHOOL__CHALLENGES', { cause: err });
      });
  }, []);

  if (challenges.length === 0) {
    return null;
  }

  const renderCards = () => {
    return challenges.map((item, index) => <ChallengesCard key={`SchoolChallenge-${index}`} {...item} />);
  };

  return (
    <section className={styles.Challenges} id="challenges">
      <TitleSection title={t('escuela.challenges.title')} />
      <Carousel numberOfElements={elementsByBreakpoint} elements={renderCards()} />
    </section>
  );
};
